import { render, staticRenderFns } from "./CourseTeachingHours.vue?vue&type=template&id=fb2e165c&"
import script from "./CourseTeachingHours.vue?vue&type=script&lang=ts&"
export * from "./CourseTeachingHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports